import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Account from '../views/Account.vue';
import Address from '../views/Address.vue';
import Print from '../views/Print.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    // по умолчанию считаем, что все пути в закрытой части и требует авторизации
    // пути публичной части необходимо отмечать метаинформацией public = true
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Стартовая страница',
                titleIcon: 'mdi-home',
                showInMainMenu: true,
                public: true
            }
        },
        {
            path: '/account',
            name: 'account',
            component: Account,
            meta: {
                title: 'Поиск по № лицевого счёта',
                titleIcon: 'mdi-home',
                showInMainMenu: true,
                public: true
            }
        },
        {
            path: '/address',
            name: 'address',
            component: Address,
            meta: {
                title: 'Поиск по адресу лицевого счёта',
                titleIcon: 'mdi-home',
                showInMainMenu: true,
                public: true
            }
        },
        {
            path: '/print',
            name: 'print',
            component: Print,
            meta: {
                title: 'Печать',
                titleIcon: 'mdi-home',
                showInMainMenu: true,
                public: true
            }
        }
    ]
});
